import axios from "axios";
import Swal from "sweetalert2";
var baseURL = process.env.REACT_APP_API_BASE_URL;


// Create an instance of axios
const api = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    headers: {
        token: localStorage.getItem('userToken')
    },
})

// handle request 
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('userToken');
        if (token) {
            config.headers["token"] = `${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// handle response
export const setApiInterceptors = (navigate) => {
    api.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error.response) {
                if (error.response.status === 401) {
                    Swal.fire({
                        icon: "error",
                        iconColor: "#AB1717",
                        title: "session expired",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    localStorage.removeItem('userToken')
                    navigate('/');
                } else {
                    Swal.fire({
                        icon: "error",
                        iconColor: "#AB1717",
                        title: "Something went wrong, Please try again.",
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
            return Promise.reject(error);
        }
    );
}

export default api;